import React, { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { getCurrentUser } from 'features/auth/ducks/selectors'
import HelpPanel from './HelpPanel'
import { HELP_EVENT } from './helpEvents'
import cleanupLegacyGuides from './cleanupLegacyGuides'

const isTyping = el => {
  const tag = el?.tagName
  return tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || !!el?.isContentEditable
}

const HelpHost = () => {
  const [open, setOpen] = useState(false)
  const currentUser = useSelector(getCurrentUser)
  const close = useCallback(() => setOpen(false), [])

  useEffect(() => {
    cleanupLegacyGuides()
  }, [])

  useEffect(() => {
    const onOpen = () => setOpen(true)
    const onKey = e => {
      if (e.key !== '?' || e.metaKey || e.ctrlKey || e.altKey || isTyping(e.target)) return
      e.preventDefault()
      setOpen(true)
    }
    window.addEventListener(HELP_EVENT, onOpen)
    document.addEventListener('keydown', onKey)
    return () => {
      window.removeEventListener(HELP_EVENT, onOpen)
      document.removeEventListener('keydown', onKey)
    }
  }, [])

  if (!currentUser?.id) return null
  return open ? <HelpPanel open onClose={close} /> : null
}

export default HelpHost
